module.exports = __webpack_public_path__ + "img/logo-canada-with-flag-light.0376c44c.svg";